<template>
	<div class="passwordless-self-register-component">
		<div class="passwordless-self-register-wrapper">
			<form id="passwordlessSelfRegisterForm">
				<div class="title">
					{{
						text.getByKey("title", {
							default: "Register",
							en: "Register",
							fr: "Enregistrer"
						})
					}}
				</div>
				<br />
				<br />
				<div class="max-600" v-show="activeComponent === 'Credentials'">
					<div class="instructions">
						<strong>
							{{
								text.getByKey("instructions", {
									default: "Please start by entering your email address.",
									en: "Please start by entering your email address.",
									fr: "Veuillez commencer par saisir votre adresse de courriel."
								})
							}}
						</strong>
					</div>
					<br />
					<div class="form-group">
						<input
							class="form-control"
							type="email"
							autocomplete="username"
							id="emailInputRegister"
							v-bind:placeholder="
								text.getByKey('userName', {
									default: 'Email',
									en: 'Email',
									fr: 'E-mail'
								})
							"
							required
							v-model="userName"
						/>
						<slot name="userNameError">
							<div class="form-error" v-show="userNameError">{{ text.get(userNameError) }}</div>
						</slot>
					</div>

					<b-button type="button" v-on:click="gatheredCredentials" class="btn mr-1" variant="primary" value="Next">
						{{ nextButtonText }}
					</b-button>
				</div>

				<div class="max-600" v-show="activeComponent === 'Attributes'">
					<user-attributes
						ref="attributes"
						v-bind:config="config.attributes"
						v-bind:common="common"
						v-bind:userData="userData"
						:text="text.shiftContext('userAttributes')"
					>
					</user-attributes>
					<div>
						<b-button type="button" class="btn mr-1" v-on:click="register" variant="primary" value="Register">
							{{
								this.config.tickets.enabled
									? text.getByKey("nextButtonText", {
											default: "Next",
											en: "Next",
											fr: "Prochain"
									  })
									: text.getByKey("registerButtonText", {
											default: "Register",
											en: "Register",
											fr: "Enregistrer"
									  })
							}}
						</b-button>
						<b-button type="button" v-on:click="back" class="btn mr-1" variant="secondary" value="Back">
							{{
								text.getByKey("backButtonText", {
									default: "Back",
									en: "Back",
									fr: "Retour"
								})
							}}
						</b-button>
					</div>
				</div>
				<div class="max-600" v-show="activeComponent === 'Tickets'" v-if="this.config.tickets.enabled">
					<tickets ref="tickets" v-bind:config="this.config.tickets" />
					<div>
						<b-button type="button" class="btn mr-1" v-on:click="checkout" variant="primary" value="Register">
							{{
								text.getByKey("checkoutrButtonText", {
									default: "Checkout",
									en: "Checkout",
									fr: "Caisse"
								})
							}}
						</b-button>
						<b-button type="button" v-on:click="back" class="btn mr-1" variant="secondary" value="Back">
							{{
								text.getByKey("backButtonText", {
									default: "Back",
									en: "Back",
									fr: "Retour"
								})
							}}
						</b-button>
					</div>
				</div>

				<div class="max-992" v-if="activeComponent === 'Checkout'">
					<b-spinner v-show="paymentLoading" variant="primary" label="Waiting"></b-spinner>

					<div v-show="!paymentLoading">
						<stripe-checkout
							ref="stripePayment"
							v-bind:config="this.config.tickets"
							v-bind:receipt_email="userName"
							v-bind:priceId="this.$refs.tickets.options[this.$refs.tickets.selectedTicketIndex].price.id"
							v-bind:priceQuantity="this.$refs.tickets.selectedTicketQuantity"
							v-bind:addonPriceId="
								this.$refs.tickets.selectedAddonIndex != -1
									? this.$refs.tickets.options[this.$refs.tickets.selectedTicketIndex].addons[
											this.$refs.tickets.selectedAddonIndex
									  ].price.id
									: null
							"
							v-bind:addonPriceQuantity="this.$refs.tickets.selectedAddonQuantity"
							v-on:loading="onPaymentLoading"
							v-on:complete="onPaymentComplete"
						/>

						<slot name="paymentError">
							<p class="payment-error">{{ text.get(paymentError) }}</p>
						</slot>

						<div>
							<b-button type="button" v-on:click="back" class="btn mr-1" variant="secondary" value="Back">
								{{
									text.getByKey("backButtonText", {
										default: "Back",
										en: "Back",
										fr: "Retour"
									})
								}}
							</b-button>
						</div>
					</div>
				</div>

				<div class="max-600" v-if="activeComponent === 'Complete'">
					<p style="text-align:center">You completed your registration. Now you can access the event.</p>
					<b-button type="button" v-on:click="complete" class="btn mr-1" variant="primary" value="Next">
						{{
							text.getByKey("accessEventText", {
								default: "Access Event",
								en: "Access Event",
								fr: "Accès à l'événement"
							})
						}}
					</b-button>
				</div>

				<br />
				<br />
				<need-help v-bind:common="common" :text="text.shiftContext('needHelp')" />
			</form>
		</div>
	</div>
</template>

<script>
import UserAttributes from "./userattribute/UserAttributes";
import StripeCheckout from "./payment/StripeCheckout";
import Tickets from "./tickets/Tickets";
import NeedHelp from "./NeedHelp";

import { log } from "@/logging";
const myLoggingName = "PasswordlessSelfRegister";

export default {
	data() {
		return {
			userName: "",
			activeComponent: "Credentials",
			userNameError: "",
			paymentError: "",
			paymentLoading: false,
			credentials: null
		};
	},
	props: {
		config: Object,
		common: Object,
		text: Object
	},
	inject: ["authService", "notificationService", "textService"],
	components: { UserAttributes, NeedHelp, StripeCheckout, Tickets },
	name: "PasswordlessSelfRegister",
	computed: {
		userData() {
			return { userName: this.userName };
		},
		nextButtonText() {
			if (this.config.attributes?.fields && this.config.attributes.fields.length > 0) {
				return this.text.getByKey("nextButtonText", {
					default: "Next",
					en: "Next",
					fr: "Poursuivre"
				});
			} else {
				return this.text.getByKey("registerButtonText", {
					default: "Register",
					en: "Register",
					fr: "Enregistrer"
				});
			}
		}
	},
	mounted() {},
	beforeUpdate() {},

	watch: {
		userName: function(newValue, oldValue) {
			// Clear out errors after submit so as not to bug user while re-entering
			if (newValue != oldValue) {
				this.userNameError = "";
			}
		}
	},

	methods: {
		initialState: function() {
			this.activeComponent = "Credentials";
		},
		back() {
			if (this.activeComponent === "Attributes") {
				this.activeComponent = "Credentials";
			}
			if (this.activeComponent === "Tickets") {
				this.activeComponent = "Attributes";
			}
			if (this.activeComponent === "Checkout") {
				this.$refs.stripePayment.destroyCheckout();
				this.activeComponent = "Tickets";
			}

			window.scrollTo(0, 0);

			return;
		},
		gatheredCredentials() {
			this.userNameError = "";
			if (!this.userName || this.userName.length == 0) {
				this.userNameError = this.text.getByKey("userNameError", {
					default: "Please provide an email address",
					en: "Please provide an email address",
					fr: "Veuillez fournir une adresse de courriel"
				});
				this.activeComponent = "Credentials";
				return;
			}

			if (this.config.loginPasswordlessIfExists) {
				this.$emit("loginIfExists", { userName: this.userName });
			}
			if (this.config.attributes?.fields && this.config.attributes.fields.length > 0) {
				this.activeComponent = "Attributes";
			} else {
				this.register();
			}
		},
		checkout() {
			this.activeComponent = "Checkout";
			this.paymentError = null;
			window.scrollTo(0, 0);
		},
		onPaymentLoading(loading) {
			this.paymentLoading = loading;
		},
		onPaymentComplete(data) {
			const attributes = this.$refs.attributes.transformAndValidate().attributes;

			attributes["custom:p:id"] = data?.id;
			attributes["custom:p:total_amount"] = `${data?.amount_total}`;
			attributes["custom:p:total_amount_fmt"] = `$${(data?.amount_total / 100).toFixed(2)}`;
			attributes["custom:p:sub_amount"] = `${data?.amount_total - data?.total_details.amount_tax}`;
			attributes["custom:p:sub_amount_fmt"] = `$${((data?.amount_total - data?.total_details.amount_tax) / 100).toFixed(2)}`;
			attributes["custom:p:amount"] = `${data?.amount_total -
				data?.virtual_venue_custom_data?.fee_amount -
				data?.total_details.amount_tax}`;
			attributes["custom:p:amount_fmt"] = `$${(
				(data?.amount_total - data?.virtual_venue_custom_data?.fee_amount - data?.total_details.amount_tax) /
				100
			).toFixed(2)}`;
			attributes["custom:p:tax_amount"] = `${data?.total_details.amount_tax}`;
			attributes["custom:p:tax_amount_fmt"] = `$${(data?.total_details.amount_tax / 100).toFixed(2)}`;
			attributes["custom:p:fee_amount"] = `${data?.virtual_venue_custom_data?.fee_amount}`;
			attributes["custom:p:fee_amount_fmt"] = `$${(data?.virtual_venue_custom_data?.fee_amount / 100).toFixed(2)}`;
			attributes["custom:p:created"] = `${data?.created}`;
			attributes["custom:p:currency"] = data?.currency;
			attributes["custom:p:receipt_email"] = data?.customer_details?.email;
			attributes["custom:p:status"] = data?.payment_status;
			attributes["custom:p:description"] = this.$refs.tickets.options[this.$refs.tickets.selectedTicketIndex]?.description;
			attributes["custom:p:addon_description"] = this.$refs.tickets.options[this.$refs.tickets.selectedTicketIndex]?.addons[
				this.$refs.tickets.selectedAddonIndex
			]?.description;

			this.authService
				.passwordlessSignup(this.userName, attributes, null)
				.then(() => {
					this.credentials = { userName: this.userName, attributes };
					this.$emit("complete", this.credentials);
					this.paymentLoading = false;
				})
				.catch(err => {
					log(myLoggingName, "Registration - Error " + err);
					this.paymentLoading = false;
				});
		},
		register() {
			if (this.config.attributes?.fields && this.config.attributes.fields.length > 0) {
				if (!this.$refs.attributes) {
					return;
				}
				const attributes = this.$refs.attributes.transformAndValidate();
				if (!attributes) {
					return;
				}

				if (this.config.tickets.enabled) {
					this.activeComponent = "Tickets";
				} else {
					this.authService
						.passwordlessSignup(this.userName, attributes.attributes, null)
						.then(() => {
							this.credentials = { userName: this.userName, attributes: attributes.attributes };
							this.$emit("complete", this.credentials);
						})
						.catch(err => {
							log(myLoggingName, "Registration - Error " + err);
						});
				}

				window.scrollTo(0, 0);
			}
		}
	}
};
</script>
<style scoped lang="scss">
@import "../scss/constants";

.passwordless-self-register-wrapper {
	max-width: 100%;
	display: block;
	margin: 0 auto;

	.max-600 {
		max-width: 600px;
		padding: 0 60px;
		margin: 0 auto;
	}

	.max-992 {
		max-width: 992px;
		padding: 0;
		margin: 0 auto;
	}

	.title {
		font-size: large;
	}
	.instructions {
		font-size: small;
	}
	.form-error {
		font-size: small;
		color: red;
	}

	.payment-error {
		color: red;
		font-weight: bold;
		font-size: 20px;
	}

	.checkout {
		border-radius: 8px;
		border: 2px solid #ddd;
		padding: 16px;
		margin: 0 0 24px 0;
		text-align: left;
		.checkout-item {
			display: flex;
			flex-direction: row;
			.checkout-item-label {
				flex-grow: 1;
			}
			.checkout-item-amount {
				text-align: right;
				width: 64px;
			}
		}
	}
}

@media (max-width: $screen-mobile-max) {
	.passwordless-self-register-wrapper {
		position: relative;
		width: 80%;
		display: block;
		margin: 0 auto;
		.title {
			font-size: large;
		}
		.instructions {
			font-size: small;
		}
		.form-error {
			font-size: small;
			color: red;
		}
	}
}
</style>
